__turbopack_context__.v({
  "accordionSlideOverwrite": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__accordionSlideOverwrite",
  "fadeIn": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__fadeIn",
  "fadeOut": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__fadeOut",
  "header": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__header",
  "linksGrid": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__linksGrid",
  "scaleIn": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__scaleIn",
  "scaleOut": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__scaleOut",
  "zoomIn": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__zoomIn",
  "zoomOut": "toolsCalculatorsSummaryLinks-module-scss-module__pXpoqa__zoomOut",
});
